import { DataExportModalDrawer } from 'App/data-export/components/DataExport/DataExportModalDrawer/DataExportModalDrawer'
import { dataExportStore } from 'App/data-export/store/dataExportStore'

export const DataExport = () => {
  const visible = dataExportStore.useSelector((s) => s.visible)

  return visible ? <DataExportModalDrawer /> : null
}
